module.exports = {
  "country": "CH",
  "artist": "Luca Hänni",
  "song": "She Got Me",
  "year": "2019",
  "place": "4",
  "spotify": "19n68Fcyr7LCfDCKdscjLI"
};